module.exports = math;


//////////////////
// WEBPACK FOOTER
// external "math"
// module id = 1133
// module chunks = 0